import Cookie from 'js-cookie'

const setCookie = (cookieName, cookieValue, domain, expire, options) => {
    Cookie.set(cookieName, cookieValue, {
        path: '/',
        domain: domain,
        expires: expire,
        ...options,
    })
}

export default setCookie
